import {FC} from 'react';
import {Box, Flex} from '@chakra-ui/react';
import {Badge} from 'ui-kit';

import {PartValue} from '../PartValue';

interface IProps {
  label: string;
  value: string;
}

export const PartRow: FC<IProps> = ({label, value}) => (
  <Flex flexDirection={'column'} gap={'6px'}>
    <Box>
      <Badge variant={'neutral'}>{label}</Badge>
    </Box>
    <Box px={'4px'} whiteSpace={'pre-wrap'} wordBreak={'break-word'}>
      <PartValue value={value} />
    </Box>
  </Flex>
);
